"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _SentimentVeryDissatisfied = _interopRequireDefault(require("@material-ui/icons/SentimentVeryDissatisfied"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flexGrow: 1,
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4)
    }, theme.breakpoints.down('xs'), {
      textAlign: 'center'
    }),
    headline: (0, _extends4.default)({}, theme.typography.h1, (0, _defineProperty2.default)({
      paddingTop: theme.spacing(2)
    }, theme.breakpoints.up('xs'), {
      fontSize: 28,
      fontWeight: 600
    })),
    content: (0, _extends4.default)({}, theme.typography.h3, (0, _defineProperty2.default)({
      padding: theme.spacing(3)
    }, theme.breakpoints.up('xs'), {
      fontSize: 24
    })),
    btnContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    icon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      fill: theme.palette.primary.main
    }
  };
}, {
  name: 'ErrorPageLayout'
});

function ErrorPageLayout(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  var setRedirect = (0, _useRedirect.default)();
  var t = (0, _useTranslate.default)();

  var handleRedirect = _react.default.useCallback(function () {
    setRedirect('/');
  }, [setRedirect]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends4.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_SentimentVeryDissatisfied.default, {
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.headline
  }, t('errorPage/title')), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.btnContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleRedirect,
    color: "primary",
    variant: "contained"
  }, t('errorPage/button'))));
}

process.env.NODE_ENV !== "production" ? ErrorPageLayout.propTypes = {
  classes: _propTypes.default.shape({
    btnContainer: _propTypes.default.string,
    content: _propTypes.default.string,
    headline: _propTypes.default.string,
    icon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
ErrorPageLayout.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = ErrorPageLayout;
exports.default = _default;